import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import { useSocket } from "../pages/chatWindow/contexts/SocketContext";
import { showSuccess } from "../utils/toastUtils";

function LayoutWithSocket() {

  const [sidebarOpen,setSidebarOpen]=useState(false);

  const socket = useSocket();

  useEffect(() => {
    if (!socket) return;

    const handleAgreement = (data) => {
      console.log("🔥 AGREEMENT OPENED:", data);
      showSuccess(`${data.leadName} opened agreement 👀`);
    };

    const handleProposal = (data) => {
      console.log("🔥 PROPOSAL OPENED:", data);
      showSuccess(`${data.leadName} opened proposal 📄`);
    };

    const handleDocument = (data) => {
      console.log("🔥 DOCUMENT OPENED:", data);
      showSuccess(`${data.leadName} opened document 📄`);
    };

    const handleAgreementAccepted = (data) => {
      showSuccess(`${data.leadName} accepted agreement ✅`);
    };

    socket.off("agreement_opened");
    socket.off("proposal_opened");
    socket.off("document_opened");
    socket.off("agreement_accepted");

    socket.on("agreement_opened", handleAgreement);
    socket.on("proposal_opened", handleProposal);
    socket.on("document_opened", handleDocument);
    socket.on("agreement_accepted", handleAgreementAccepted);

    return () => {
      socket.off("agreement_opened", handleAgreement);
      socket.off("proposal_opened", handleProposal);
      socket.off("document_opened", handleDocument);
      socket.off("agreement_accepted", handleAgreementAccepted);
    };
  }, [socket]);

  return (
    <div className="main-wrapper">

<Header
sidebarOpen={sidebarOpen}
setSidebarOpen={setSidebarOpen}
/>
<Sidebar
sidebarOpen={sidebarOpen}
setSidebarOpen={setSidebarOpen}
/>

{sidebarOpen && (
  <div
    className="sidebar-overlay"
    onClick={() => setSidebarOpen(false)}
  />
)}
      <div className="page-wrapper">
        <Outlet />
      </div>
    </div>
  );
}

function DashboardLayout() {
  return <LayoutWithSocket />;
}

export default DashboardLayout;
